import React from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import classNames from 'classnames/bind';

import styles from './ZoomableImage.module.scss';

const cx = classNames.bind(styles);

export default function ZoomableImage({ src, alt = '' }) {
  return (
    <div className={cx('image-wrapper')}>
      <TransformWrapper>
        {({ zoomIn, zoomOut, resetTransform }) => (
          <React.Fragment>
            <TransformComponent>
              <img src={src} alt={alt} />
            </TransformComponent>
            <div className={cx('actions')}>
              <button className={cx('button')} onClick={() => zoomIn()}>
                &#43;
              </button>
              <button className={cx('button')} onClick={() => zoomOut()}>
                &minus;
              </button>
              <button className={cx('button')} onClick={() => resetTransform()}>
                &#x21bb;
              </button>
            </div>
          </React.Fragment>
        )}
      </TransformWrapper>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ZoomableImage/ZoomableImage.js